<template>
  <div class="px-4 text-neutral-700 py-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:mt-3">
    <vetster-checkbox-input
      v-for="pet in getSpeciesRadioOptions"
      :key="pet.value"
      v-model="value.species"
      :value="pet.value"
      :label="pet.text"
      :icon="petIcon(pet.value)"
      is-checkbox-card
      type="radio"
    />
  </div>
</template>

<script>
import VetsterCheckboxInput from '@/brand-components/VetsterCheckboxInput';
import useFormHelpers from '@/composables/use-form-helpers';
import PetIcons from '@/mixins/PetIcons';

export default {
  name: 'VetsterSpeciesForm',

  components: { VetsterCheckboxInput },

  mixins: [PetIcons],

  props: {
    formInputs: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const { getSpeciesRadioOptions } = useFormHelpers();

    return { getSpeciesRadioOptions };
  },

  data() {
    return {
      value: { ...this.formInputs },
    };
  },

  watch: {
    value: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
  },
};
</script>
